"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardRenderData = void 0;
var vue_1 = require("vue");
var CardRowData_1 = require("./CardRowData");
exports.CardRenderData = vue_1.default.component('CardRenderData', {
    props: {
        renderData: {
            type: Object,
            required: true,
        },
    },
    components: {
        CardRowData: CardRowData_1.CardRowData,
    },
    template: "\n        <div class=\"card-rows\">\n            <CardRowData v-for=\"(cardData, i) in renderData.rows\" :rowData=\"cardData\" :key=\"i\" />\n        </div>\n    ",
});
//# sourceMappingURL=CardRenderData.js.map